<template>
    <div class="main-container bgGray CourseDetails_box">
        <div class="w mineOrderBox">
            <bread-crumb
                firstPath="/pcViews/personal"
                firstNav="个人中心"
                secondPath="/pcViews/personal/order"
                secondNav="我的订单"
                breadcrumbText="订单详情"
            ></bread-crumb>
            <!-- 订单信息模块 -->
            <div>
                <div class="title">订单详情</div>
                <!-- 订单状态 -->
                <div class="order-type min-el-step">
                    <div class="order_type_title">订单状态</div>
                    <div class="order_news">
                        <div class="order_news_status">
                            <div class="order_num">
                                订单编号：{{ orderNumber }}
                            </div>
                            <div class="order_status" :class="orderStatusClass">
                                {{ orderStatusTxt }}
                            </div>
                            <div class="careful" v-if="status === '4'">
                                <div style="width: 46px">注意：</div>
                                <div style="flex: 1">
                                    如已经产生扣费，订单仍
                                    显示支付失败，请尽快与 校方联系。
                                </div>
                            </div>
                            <el-button
                                type="info"
                                plain
                                round
                                size="mini"
                                v-if="status === '3' && hasInvice"
                                @click="viewInvoice"
                                >查看发票详情</el-button
                            >
                            <el-button
                                type="info"
                                plain
                                round
                                size="mini"
                                v-if="status === '0' && payMode !== '0'"
                                @click="unpaidOrderPayment"
                                :disabled="disabled"
                                >立即支付</el-button
                            >
                            <div
                                class="dengBtn"
                                v-if="status === '0' && payMode === '0'"
                            >
                                等待确认
                            </div>
                        </div>
                        <div class="order-bz">
                            <el-steps :active="active" align-center>
                                <el-step
                                    title="提交订单"
                                    :description="description1"
                                ></el-step>
                                <el-step
                                    :title="title"
                                    :description="description2"
                                ></el-step>
                                <el-step
                                    title="完成"
                                    :description="description2"
                                ></el-step>
                            </el-steps>
                        </div>
                    </div>
                </div>
                <!-- 商品详情 -->
                <div class="order_xnwes1">
                    <div class="order_xnwes_item">
                        <div class="order_bt">订单状态</div>
                        <div class="order_xnwes_text">
                            <div>
                                <p>顾客姓名</p>
                                <span>：</span>
                                <span>{{ member.userName }}</span>
                            </div>
                            <div>
                                <p>客户ID</p>
                                <span>：</span>
                                <span>{{ member.showName }}</span>
                            </div>
                            <div>
                                <p>电话</p>
                                <span>：</span>
                                <span>{{ member.mobile }}</span>
                            </div>
                            <div>
                                <p>邮箱</p>
                                <span>：</span>
                                <span>{{ member.email }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="order_xnwes_item blr1">
                        <div class="order_bt">付款信息</div>
                        <div class="order_xnwes_text">
                            <div>
                                <p>付款方式：</p>
                                <span v-if="payMode == 3">银联</span>
                                <span v-else-if="payMode == 4">微信</span>
                                <span v-else>线下支付</span>
                            </div>
                            <div>
                                <p>付款时间：</p>
                                <span v-if="finishTime">{{ finishTime }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="order_xnwes_item">
                        <div class="order_bt">发票信息</div>
                        <div class="order_xnwes_text">
                            <div>
                                <p>发票类型：</p>
                                <span>电子发票</span>
                            </div>
                            <div>
                                <p>发票抬头：</p>
                                <span v-if="titleType == 1">单位</span>
                                <span v-else>个人</span>
                            </div>
                            <div>
                                <p>发票内容：</p>
                                <span>商品明细</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 商品清单、发票信息、 支付方式-->
                <div class="goods_news_box mtop30">
                    <!-- 商品清单 -->
                    <div>
                        <div class="order_type_title">商品清单</div>
                        <el-table
                            :data="tableData"
                            style="width: 100%; margin-top: 30px"
                            border
                        >
                            <el-table-column
                                prop="data"
                                width="150"
                                align="center"
                            >
                                <div class="practice_test">
                                    <img
                                        v-if="businessType === '0'"
                                        src="~assets/images/temporary/d_training.png"
                                        alt=""
                                    />
                                </div>
                            </el-table-column>
                            <el-table-column prop="name" label="商品">
                            </el-table-column>
                            <el-table-column
                                prop="goodsNum"
                                align="center"
                                label="商品编号"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="num"
                                label="商品数量"
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="price"
                                align="center"
                                label="价格"
                            >
                                <template #default="scope">
                                    <span>￥{{ scope.row.price }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <!-- 发票信息、支付方式 -->
                    <div class="orderCorrelationInfo mtop30" v-if="status === '0'">
                        <!-- 发票信息开始 -->
                        <order-invoice>
                            <div
                                class="order_info_title"
                                slot="order_info_title"
                            >
                                <p>发票信息</p>
                                <span
                                    >*开企业抬头发票须填写纳税人识别号，以免影响报销</span
                                >
                            </div>
                            <div
                                class="orderInvoiceContent"
                                slot="orderInvoiceContent"
                            >
                                <div>开具发票</div>
                                <div v-if="!changeInvoiceType">
                                    <p v-if="invoiceInfo.titleType == '0'">
                                        个人
                                    </p>
                                    <p v-else>单位</p>
                                    <p>商品明细</p>
                                </div>
                                <div v-else>
                                    <p>电子发票</p>
                                    <em>-</em>
                                    <p v-if="invoiceInfo.titleType == '0'">
                                        个人
                                    </p>
                                    <p v-else>单位</p>
                                </div>
                                <div>
                                    <span @click="showOrderInvoiceDialog"
                                        >修改</span
                                    >
                                </div>
                            </div>
                        </order-invoice>
                        <invoice-info
                            :invoiceVisible="invoiceVisible"
                            :remoteInvoiceClose="remoteInvoiceClose"
                            :invoiceInfo="invoiceInfo"
                            @sendWriteInvoiceInfo="acceptWriteInvoiceInfo"
                        ></invoice-info>
                        <!-- 发票信息结束 -->
                        <!-- 支付方式开始 -->
                        <order-payment-method
                            :invoiceInfo="invoiceInfo"
                            :price="totalAmount"
                            :salePrice="actualAmount"
                            :hasOrder="tableData[0].hasOrder"
                            :businessId="businessId"
                            :orderPayMode="payMode"
                            :status="status"
                            :orderId="orderId"
                        >
                            <div
                                class="order_info_title"
                                slot="order_info_title"
                            >
                                <p>支付方式</p>
                            </div>
                        </order-payment-method>
                        <!-- 支付方式结束 -->
                    </div>
                    <!-- 发票信息、支付方式结束  -->
                </div>
            </div>
        </div>
        <!-- 查看已完成订单 —— 发票信息 -->
        <personal-invoice-info
            :invoiceVisible="fInvoiceVisible"
            :invoiceInfo="fInvoiceInfo"
            :remoteInvoiceClose="remoteFInvoiceClose"
        ></personal-invoice-info>
    </div>
</template>

<script>
import BreadCrumb from "components/contents/breadCrumb/BreadCrumb";
import OrderInvoice from "components/contents/orderInvoice/OrderInvoice";
import OrderPaymentMethod from "components/contents/orderPaymentMethod/OrderPaymentMethod";
import PersonalInvoiceInfo from "@/components/common/personalInvoiceInfo/PersonalInvoiceInfo";
import InvoiceInfo from "components/common/invoiceInfo/InvoiceInfo";

import VueEvent from '@/VueEvent.js'
import { PcCookie, Key } from "@/utils/cookie";

import { getOrderDetails } from "api/order";

export default {
    components: { BreadCrumb, OrderInvoice, OrderPaymentMethod, InvoiceInfo, PersonalInvoiceInfo },
    computed: {
        //订单状态类名
        orderStatusClass() {
            let className = "";
            if (this.status == "0") {
                className = "warning";
            } else if (this.status == "1" || this.status == "4") {
                className = "danger";
            } else if (this.status == "2") {
                className = "";
            } else if (this.status == "3") {
                className = "success";
            }
            return className;
        },
        //订单状态文字
        orderStatusTxt() {
            let txt = "";
            if (this.status == "0") {
                txt = "待支付";
            } else if (this.status == "1") {
                txt = "已取消";
            } else if (this.status == "2") {
                txt = "交易关闭";
            } else if (this.status == "3") {
                txt = "完成";
            } else if (this.status == "4") {
                txt = "支付失败";
            }
            return txt;
        },
    },
    data() {
        return {
            unpaid:false,//是否待支付
            businessId:"",//培训报名id
            orderId: "", //订单id
            invoiceVisible: false,//发票填写模块开关
            invoiceInfo: {//发票信息
                titleName: "",
                phoneNumber: "",
                taxNumber: "",
                titleType: "0",
            },
            changeInvoiceType: false,//改变发票状态
            fInvoiceVisible:false,//已完成订单 -- 发票回显开关
            fInvoiceInfo:{//已完成订单 -- 发票信息
                titleName: "",
                phoneNumber: "",
                taxNumber: "",
                titleType: "0",
            },
            status: null,
            title: "",
            description1: "",
            description2: "",
            active: 2,
            tableData: [
                {
                    num: 1,
                    name: "",
                    startTime: "",
                    endTime: "",
                    hasOrder: "",
                },
            ],
            agree: {
                visible: false,
                title: "发票详情",
                indentid: "",
            },
            visible: false,
            isPayment: true, //判断调用接口后，是否成功
            sessionId: null,
            actualAmount: "",
            totalAmount: "",
            businessType: "",
            courseInfo: "",
            member: {},
            payMode: null,
            finishTime: "",
            titleName: "",
            goodsNews: {},
            orderNumber: "",
            createDate: "",
            titleType: "",
            hasInvice:false,
            disabled: false,
            formUrl: "https://pay.imaa.edu.cn/studentms-mobile/interface/pay_free_trans",
            ACTION_SIGN: "",
            ACTION_NAME: "",
            ACTION_INFO: "",
        };
    },
    mounted(){
        VueEvent.$on("unpaidOrderPaymentFail",() => {
            this.disabled = false;
        })
    },
    created() {
        this.orderId = this.$route.query.orderId;
        this.fetchOrderDetail();
    },
    methods: {
        //待支付订单 -- 立即支付
        unpaidOrderPayment(){
            this.disabled = true;
            VueEvent.$emit('unpaidOrderPaymentVueEvent');
        },
        //获取订单信息
        fetchOrderDetail() {
            const sessionId = PcCookie.get(Key.jsessIdKey);
            getOrderDetails(sessionId, this.orderId).then((res) => {
                if (res.errorCode === "2000") {
                    this.businessId = res.body.data.trainSignup.id;
                    this.businessType = res.body.data.businessType;
                    this.tableData[0]["name"] =
                        this.businessType === "0"
                            ? res.body.data.categoryInfo.name
                            : res.body.data.courseInfo.name;
                    if (this.businessType === "0") {
                        this.tableData[0]["goodsNum"] =
                            res.body.data.categoryInfo.code;
                    } else {
                        this.tableData[0]["goodsNum"] =
                            res.body.data.courseInfo.code;
                    }
                    this.tableData[0]["price"] = res.body.data.actualAmount;
                    this.courseInfo = res.body.data.courseInfo;
                    this.description1 = res.body.data.createDate;
                    this.actualAmount = res.body.data.actualAmount;
                    this.totalAmount = res.body.data.totalAmount;
                    this.member = res.body.data.member;
                    this.payMode = res.body.data.payMode;
                    this.orderNumber = res.body.data.orderNumber;
                    this.createDate = res.body.data.createDate;
                    this.finishTime = res.body.data.finishTime;
                    this.status = res.body.data.status;
                    // 订单状态
                    if (this.status === "0") {
                        this.title = "待支付";
                        this.active = 2;
                    } else if (this.status === "3") {
                        this.title = "支付";
                        this.active = 3;
                        this.description2 = res.body.data.finishTime;
                    } else if (this.status === "2") {
                        this.title = "交易关闭";
                        this.active = 2;
                        this.description2 = res.body.data.closeTime;
                    } else {
                        this.title = "已取消";
                        this.active = 2;
                        this.description2 = res.body.data.cancelTime;
                    }
                    if(res.body.data.invoiceInfo){
                        this.hasInvice = true;
                        this.titleType = res.body.data.invoiceInfo.titleType;
                        this.titleName = res.body.data.invoiceInfo.titleName;
                        this.invoiceInfo.phoneNumber = res.body.data.invoiceInfo.phoneNumber;
                        this.invoiceInfo.taxNumber = res.body.data.invoiceInfo.taxNumber;
                        this.invoiceInfo.titleName = res.body.data.invoiceInfo.titleName;
                        this.invoiceInfo.titleType = res.body.data.invoiceInfo.titleType;
                        this.fInvoiceInfo.phoneNumber = res.body.data.invoiceInfo.phoneNumber;
                        this.fInvoiceInfo.taxNumber = res.body.data.invoiceInfo.taxNumber;
                        this.fInvoiceInfo.titleName = res.body.data.invoiceInfo.titleName;
                        this.fInvoiceInfo.titleType = res.body.data.invoiceInfo.titleType;
                    }
                    if(this.status == '0' && this.payMode != '0'){
                        this.unpaid = true;
                    }else{
                        this.unpaid = false;
                    }
                }
            });
        },
        //接受子组件 -- 填写、修改发票信息传过来的参数
        acceptWriteInvoiceInfo(data) {
            this.invoiceInfo.titleName =
                data.status === '0' ? data.userName : data.companyName;
            this.invoiceInfo.phoneNumber =
                data.status === '0' ? data.phone : data.companyPhone;
            this.invoiceInfo.taxNumber =
                data.status === '0' ? "" : data.invoiceNum;
            this.invoiceInfo.titleType = data.status;
            this.changeInvoiceType = true;
        },
        //显示填写、修改发票信息dialog
        showOrderInvoiceDialog() {
            this.invoiceVisible = true;
        },
        //关闭填写、修改发票信息dialog
        remoteInvoiceClose() {
            this.invoiceVisible = false;
        },
        //显示已完成订单发票信息
        viewInvoice(){
            this.fInvoiceVisible = true;
        },
        //关闭已完成订单发票信息
        remoteFInvoiceClose(){
            this.fInvoiceVisible = false;
        },
    },
};
</script>

<style>
.goodsNews span {
    flex: 1;
}
.goodsNews em {
    margin: 0 20px;
}
.goodsNews p {
    margin: 0 !important;
}
.goodsNews {
    display: flex;
    flex-direction: row;
    margin: 0 12px;
    line-height: 32px;
}
.practice_test {
    height: 95px;
    position: relative;
    display: flex;
}
.practice_test img {
    width: 100%;
    height: 100%;
}
.practice_test span {
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    font-size: 14px;
    color: #fff;
    padding: 0 3px 0 3px;
}
.el-table th {
    background: #f1f1f1;
}
.min-el-step .el-step__description.is-finish {
    color: #b21f27;
}
.min-el-step .el-step__title.is-finish {
    color: #b21f27;
}
.min-el-step .el-step__head.is-finish {
    color: #b21f27;
    border-color: #b21f27;
}
.min-el-step .el-steps {
    width: 100%;
}
</style>

<style  scoped>
.blr1 {
    border-left: dashed 1px #dadada;
    border-right: dashed 1px #dadada;
}
.order_xnwes1 {
    margin-top: 30px;
    height: 232px;
    padding-top: 30px;
    padding-bottom: 27px;
    background: #fff;
    display: flex;
    flex-direction: row;
}
.order_bt {
    box-sizing: content-box;
    height: 36px;
    line-height: 36px;
    font-size: 20px;
    color: #000;
    font-weight: 600;
}
.gppds_price.active span {
    color: #b21f27;
    font-weight: bold;
}
.payBtn {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 18px;
    color: #fff;
    border-radius: 20px;
    cursor: pointer;
    background: #b21f27;
}
.gppds_price span {
    font-size: 24px;
    font-weight: bold;
}
.gppds_price {
    font-size: 16px;
    line-height: 34px;
}
.total_price {
    font-size: 16px;
    color: #3b3b3b;
    line-height: 24px;
}
.pay_title {
    padding-left: 24px;
    height: 38px;
    line-height: 38px;
    font-size: 20px;
    color: #000;
    border-bottom: solid 1px #dadada;
}
.invoice_box p {
    margin-right: 32px;
}
.invoice_box {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 20px;
    height: 66px;
    font-size: 16px;
    color: #3b3b3b;
}
.flex1 {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 10px 16px;
}
.pay_price_box {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.payTypeBox {
    padding: 0 20px;
    height: 60px;
    font-size: 16px;
    color: #3b3b3b;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.flexRow {
    margin-right: 30px;
    display: flex;
    flex-direction: row;
}
.pay_type.active p {
    background: #fff;
    border-color: #b21f27 !important;
}
.pay_type img {
    margin: 0 5px 0 13px;
}
.pay_type p {
    box-sizing: content-box;
    width: 6px;
    height: 6px;
    border: solid 5px #eaf0ee;
    background: #eaf0ee;
    border-radius: 50%;
}
.pay_type {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
    width: 226px;
    height: 64px;
    font-size: 14px;
    color: #3b3b3b;
    border: solid 1px #dadada;
    background: #fff;
    cursor: pointer;
}
.pay_box {
    /* float: right; */
    display: flex;
    width: 226px;
    height: 182px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.goods_img {
    width: 120px;
    height: 96px;
}
.goods_news_box {
    padding: 0 20px 20px;
    height: 100%;
    background: #fff;
}
.order_xnwes_text div p {
    width: 94px;
    font-size: 18px;
    text-align: justify;
    text-align-last: justify;
    color: #818181;
}
.order_xnwes_text div span {
    font-size: 18px;
}
.order_xnwes_text div {
    height: 36px;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #818181;
}
.order_xnwes_text {
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
}
.order_xnwes_item {
    height: 100%;
    width: 433.33%;
    padding: 0 32px;
    display: flex;
    flex-direction: column;
    background: #fff;
}
.order_xnwes {
    margin-top: 30px;
    height: 262px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.careful {
    display: flex;
    flex-direction: row;
    width: 196px;
    font-size: 14px;
    line-height: 18px;
    color: #ff3b44;
}
.order-bz {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
    height: 100%;
}
.order_status.danger {
    color: #ff8e09;
}
.order_status.warning {
    color: #b21f27;
}
.order_status.success {
    color: #1fb226;
}
.order_status.cancel {
    color: #e0e2e0;
}
.order_status {
    margin: 15px 0;
    font-size: 30px;
    font-weight: bold;
}
.order_num {
    font-size: 16px;
    color: #818181;
}
.order_news_status {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 260px;
    height: 100%;
    border-right: solid 1px #dadada;
}
.order_news {
    display: flex;
    flex-direction: row;
    margin-top: 10px;
    height: 244px;
}
.order_type_title {
    box-sizing: content-box;
    padding: 30px 22px 0;
    height: 36px;
    line-height: 36px;
    font-size: 20px;
    color: #000;
    border-bottom: solid 1px #dadada;
}
.order-type {
    padding: 0 20px;
    height: 333px;
    background: #fff;
}
.title {
    padding-left: 16px;
    font-size: 26px;
    color: #000;
    line-height: 86px;
}
.activeType {
    border: solid 2px #b21f27 !important;
}
.pay_type.activeType p {
    background: #fff;
    border-color: #b21f27 !important;
}
.dengBtn {
    font-size: 12px;
    padding: 7px 15px;
    color: #909399;
    background: #f4f4f5;
    border-radius: 20px;
    border: 1px solid #d3d4d6;
}
</style>
